import onGetStatusUsers from './onGetStatusUsers';
import onGetMoreStatusUsers from './onGetMoreStatusUsers';

export default {
  onGetStatusUsers,
  onGetMoreStatusUsers,
};
